import actions from '../actions/process';
import base from '../../../reducers/base';

const reducer = base(actions.types);
export default reducer;
